"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
const Property_1 = require("../interfaces/Property");
/**
 * Note API sdk
 */
class Property {
    constructor() {
        if (!(authData_1.Auth.getUserToken() && authData_1.Auth.getDomainToken())) {
            throw new Error("Cannot use Property service without authenticated user and opened domain!, " +
                "please use the Authenticator service first");
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    static simplifyProps(properties) {
        const simplifiedProps = {};
        properties.forEach(prop => {
            switch (prop.valueType) {
                case Property_1.PropertyValueTypes.BOOL:
                    simplifiedProps[prop.key] = (prop.value === '1' || prop.value === 't' || prop.value === 'true');
                    break;
                case Property_1.PropertyValueTypes.DATETIME:
                    simplifiedProps[prop.key] = new Date(prop.value);
                    break;
                case Property_1.PropertyValueTypes.INT:
                    simplifiedProps[prop.key] = parseInt(prop.value, 10);
                    break;
                case Property_1.PropertyValueTypes.FLOAT:
                    simplifiedProps[prop.key] = parseFloat(prop.value);
                    break;
                case Property_1.PropertyValueTypes.JSON:
                    simplifiedProps[prop.key] = JSON.parse(prop.value);
                    break;
                default:
                    simplifiedProps[prop.key] = prop.value;
            }
        });
        return simplifiedProps;
    }
    /**
     * Create Property based on iPropertyCreate params
     * @param data
     * @returns Promise<iProperty>
     */
    create(data) {
        return this.api.post(`property`, data);
    }
    /**
     * Create Many Properties (on one object such as node, label, ..)
     * @param data
     * @returns Promise<iProperty>
     */
    createMany(data) {
        return this.api.post(`property/many`, data);
    }
    /**
     * Update a property based on id
     *
     * @param id
     * @param data
     * @returns Promise<iProperty>
     */
    update(id, data) {
        return this.api.patch(`property/${id}`, data);
    }
    /**
     * Update Many properties
     *
     * @param id
     * @param data
     * @returns Promise<iProperty>
     */
    updateMany(data) {
        return this.api.patch(`property/many`, data);
    }
    /**
     * Delete a property based on id
     *
     * @param id: string | number
     * @returns
     */
    delete(id) {
        return this.api.delete(`property/${id}`);
    }
}
exports.Property = Property;
//# sourceMappingURL=data:application/json;base64,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